/**
 * All the icons used in the block.
 */
/**
 * Internal dependencies
 */
import SVGArrowCircleIcon from './images/arrow-circle-icon.svg'
import SVGArrowIcon from './images/arrow-icon.svg'
import SVGArrowOutlineIcon from './images/arrow-outline-icon.svg'
import SVGCheckCircleIcon from './images/check-circle-icon.svg'
import SVGCheckIcon from './images/check-icon.svg'
import SVGCheckOutlineIcon from './images/check-outline-icon.svg'
import SVGCrossCircleIcon from './images/cross-circle-icon.svg'
import SVGCrossIcon from './images/cross-icon.svg'
import SVGCrossOutlineIcon from './images/cross-outline-icon.svg'
import SVGPlusCircleIcon from './images/plus-circle-icon.svg'
import SVGPlusIcon from './images/plus-icon.svg'
import SVGPlusOutlineIcon from './images/plus-outline-icon.svg'
import SVGStarCircleIcon from './images/star-circle-icon.svg'
import SVGStarIcon from './images/star-icon.svg'
import SVGStarOutlineIcon from './images/star-outline-icon.svg'

export const ArrowIcon = ( fill = undefined ) => <SVGArrowIcon style={ { fill } } />
export const CheckIcon = ( fill = undefined ) => <SVGCheckIcon style={ { fill } } />
export const CrossIcon = ( fill = undefined ) => <SVGCrossIcon style={ { fill } } />
export const PlusIcon = ( fill = undefined ) => <SVGPlusIcon style={ { fill } } />
export const StarIcon = ( fill = undefined ) => <SVGStarIcon style={ { fill } } />

/**
 * Circle icons
 */

export const ArrowCircleIcon = ( fill = undefined ) => <SVGArrowCircleIcon style={ { fill } } />
export const CheckCircleIcon = ( fill = undefined ) => <SVGCheckCircleIcon style={ { fill } } />
export const CrossCircleIcon = ( fill = undefined ) => <SVGCrossCircleIcon style={ { fill } } />
export const PlusCircleIcon = ( fill = undefined ) => <SVGPlusCircleIcon style={ { fill } } />
export const StarCircleIcon = ( fill = undefined ) => <SVGStarCircleIcon style={ { fill } } />

/**
 * Outline icons
 */

export const ArrowOutlineIcon = ( fill = undefined ) => <SVGArrowOutlineIcon style={ { fill } } />
export const CheckOutlineIcon = ( fill = undefined ) => <SVGCheckOutlineIcon style={ { fill } } />
export const CrossOutlineIcon = ( fill = undefined ) => <SVGCrossOutlineIcon style={ { fill } } />
export const PlusOutlineIcon = ( fill = undefined ) => <SVGPlusOutlineIcon style={ { fill } } />
export const StarOutlineIcon = ( fill = undefined ) => <SVGStarOutlineIcon style={ { fill } } />
